<adf-login
  [copyrightText]="settings.appCopyright | translate"
  successRoute="/personal-files"
  logoImageUrl="./assets/images/alfresco-logo.svg"
  backgroundImageUrl="./assets/images/Wallpaper-BG-generic.svg"
  [showRememberMe]="false"
  [showLoginActions]="false" />
